function setupDealerPage() {  

  if (jQuery('section > div').hasClass('dealers') && !jQuery('.dealers').hasClass('single')) {
    setupDealerInfiniteScroll();  
    intializeDealerCookies();
    loadDealerFilterValues();
    setupDealerCheckMarks();  
    setupDealerLocationFilter();
    filterDealerResults();
  }
  
  if (jQuery('section > div').hasClass('dealers') && jQuery('.dealers').hasClass('single')) {
    setupDealerMessage();    
  }  
  
  jQuery(".dealer-carousel").owlCarousel({
    navigation: true,
    navigationText: ["<img src='/img/icons/slider-arrow-left.png'/>", "<img src='/img/icons/slider-arrow-right.png'/>"],
    pagination: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    singleItem: true,
  });
}

var dealerPage = 1;
var dealerLastPage = false;
var dealerInfiniteInprogress = false;
var dealerLoadMoreTimeout = null;
var map = null;
var geocoder = null;
var dealerFilter = {};

function intializeDealerCookies() {
  jQuery.cookie.json = true;
  var emptyFilter = {
    state: '',
    productLines: '',
    dealerType: '',
    certificationLevel: '',
    services: ''
  };
  dealerFilter = jQuery.cookie('dealerFilter') ? jQuery.cookie('dealerFilter') : emptyFilter;
}

function setupDealerMessage() {  
  jQuery('.dealers.single .send-message').colorbox({
    html : "<div class='panel panel-default'>\
      <div class='panel-heading'>\
        <h1 class='text-bold margin-top-none margin-bottom-none'>Send a message to <span id='dealer-name'></span></h1>\
      </div>\
      <div class='panel-body'>\
        <form id='dealer-message'>\
          <div class='form-group'>\
            <label for='from'>*Your Email Address</label>\
            <input type='email' class='form-control' name='from' id='from' required='required'/>\
          </div>\
          <div class='form-group'>\
            <label for='first_name'>*Your First Name</label>\
            <input type='text' class='form-control' name='first_name' id='first-name' required='required'/>\
          </div>\
          <div class='form-group'>\
            <label for='last_name'>*Your Last Name</label>\
            <input type='text' class='form-control' name='last_name' id='last-name' required='required'/>\
          </div>\
          <div class='form-group'>\
            <label for='phone_number'>*Your Phone Number</label>\
            <input type='text' class='form-control' name='phone_number' id='phone-number' required='required'/>\
          </div>\
          <div class='row'>\
            <div class='form-group col-md-4'>\
              <label for='phone_number'>*City</label>\
              <input type='text' class='form-control' name='city' id='city' required='required'/>\
            </div>\
            <div class='form-group col-md-4'>\
              <label for='phone_number'>*State</label>\
              <input type='text' class='form-control' name='state' id='state' required='required'/>\
            </div>\
            <div class='form-group col-md-4'>\
              <label for='zip_code'>*Zip Code</label>\
              <input type='text' class='form-control' name='zip_code' id='zip-code' required='required'/>\
            </div>\
          </div>\
          <div class='form-group'>\
            <label for='zip'>Construction Type</label>\
            <select type='text' class='form-control' name='construction_type' id='construction_type'>\
              <option value='new-build'>New Build</option>\
              <option value='remodel'>Remodel</option>\
            </select>\
          </div>\
          <div class='form-group'>\
            <label for='detail'>*Message</label>\
            <textarea class='form-control' name='detail' id='detail' required='required'></textarea>\
          </div>\
          <button type='submit' id='send' class='btn btn-default btn-primary pull-right'>Send</button>\
        </form>\
      </div>",
    maxWidth: '80%',
    closeButton: false,
    maxHeight: '90%',
    innerWidth: function() {
      return jQuery(window).width() - 80;
    },
    innerHeight: '100%',
    scrolling: false,
    onComplete : function() {  
      jQuery('#cboxContent #dealer-name').html(jQuery(this).attr('dealer-name'));
      var dealerUuid = jQuery(this).attr('dealer-uuid');
      
      jQuery('#cboxContent #dealer-message').unbind().submit(function(e) {  
        e.preventDefault();
        
        jQuery.post('/marketplace/send-message/' + dealerUuid, jQuery(this).serialize()
          , function(response) {
            jQuery('#cboxContent #dealer-message').html("<div class='text-center alert alert-success'>Your message has been sent!</div>")
            
        }).fail(function(response) {
          alert(response.responseText);
        });  
      });
      
      jQuery.colorbox.resize();
    }
  });
}

function initializeMap() {
  var mapOptions = {
    zoom: 5,
  }
  
  if (document.getElementById('map-canvas') === undefined || document.getElementById('map-canvas') === null ) return

  map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
  geocoder = new google.maps.Geocoder();
}

function reCenterGoogleMaps(state) {
  geocoder.geocode({ 'address' : state }, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      map.setCenter(results[0].geometry.location);
      if (state.length > 2)
        map.setZoom(5);
      else
        map.setZoom(6);
          
    } else {
      //alert("Geocode was not successful for the following reason: " + status);
    }
  });
}

function updateGoogleMapsMarkers(dealer) {  
  jQuery.each(dealer.Locations, function(index, location) {  

    if (!location.latitude || !location.longitude) 
      return;
      
    var myLatlng = new google.maps.LatLng(location.latitude, location.longitude);   
    var image = "/img/icons/poi.png";
    var dealerName = dealer.name.replace(/,/g,'');
    
    if (dealer.dealer_type_id == 1) { //Applicator
      image = "/img/icons/poi-applicator.png";
    } else if(dealer.dealer_type_id == 2) { //Builder
      image = "/img/icons/poi-builder.png";  
    }  
    
    var pinImage = new google.maps.MarkerImage(image,
      new google.maps.Size(34, 33),
      new google.maps.Point(0, 0),
      new google.maps.Point(34, 33)
    );  
    
    var marker = new google.maps.Marker({
      map: map,
      position: myLatlng, 
      icon: pinImage,
      title : dealerName
    });
   
    var infowindow = new google.maps.InfoWindow({
      content: jQuery(prepareDealerTemplate(dealer, 'googleMapDealerInfo')).html(),
    });
    
    google.maps.event.addListener(marker, 'click', function() {
      infowindow.open(map, marker);
    });
  });
}

function setupDealerLocationFilter() {
  jQuery('.dealers #state').unbind().change(function(e) {
    e.preventDefault();
    filterDealerResults();
  });
}

function setupDealerCheckMarks() {
  jQuery('.dealers .check-mark').unbind().click(function(e) {
    e.preventDefault();
    
    if (jQuery(this).hasClass('checked'))
      jQuery(this).removeClass('checked');      
    else
      jQuery(this).addClass('checked');
    
    filterDealerResults();
  });
}

function setupDealerInfiniteScroll() {
  jQuery(window).scroll(function() {
    if (jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() - 100) {
      loadMoreDealers();
    }
  });
}

function loadMoreDealers() {
  if (dealerInfiniteInprogress)
    return;
  
  if (dealerLastPage)
    return;
  
  dealerInfiniteInprogress = true;
  
  dealerLoadMoreTimeout = setTimeout(function(){ 
    dealerPage++;
    var parameters = '&productLine=' + dealerFilter.productLines + '&dealerType=' + dealerFilter.dealerType + '&dealerService=' + dealerFilter.services + '&dealerCertificationLevel=' + dealerFilter.certificationLevel + '&state=' + dealerFilter.state;
    jQuery.get('/marketplace/list?limit=9&page=' + dealerPage + parameters, function(data) {
      if (data.length > 0 ) {
        jQuery.each(data, function(index, dealer) {   
          appendDealerToGallery(dealer);
        });
        
        dealerInfiniteInprogress = false;
      } else {
        dealerLastPage = true;
        dealerInfiniteInprogress = false;
      }
    });
  }, 200);
}

function prepareDealerTemplate(dealer, templateName) {
  var templateName = templateName ? templateName : 'dealer';  
  var template = jQuery('#templates #' + templateName).clone();
  var dealerName = dealer.name.replace(/,/g,'');
  
  jQuery(template).find('#name').html(dealerName);  
  
  if (dealerName.length > 44)
    jQuery(template).find('#name').css('font-size', '22px');
    
  jQuery(template).find('#title').html(dealer.title);  
  jQuery(template).find('a').attr('href', dealer.url);  
  jQuery(template).find('img').attr('src', dealer.dealerImageUrl); 
  jQuery(template).find('#metropolitan-areas').html(dealer.metropolitan_areas);
  
  var areaCount = 1;
  jQuery.each(dealer.Areas, function(index, area) {
    var areaLine = '<span>' + area.State.name + '</span>';
    if (dealer.Areas.length > areaCount)
      areaLine += ', ';
    
    jQuery(template).find('#areas').append(areaLine);
    areaCount++;
  });
  
  var serviceCount = 1;
  jQuery.each(dealer.Services, function(index, service) {
    var serviceLine = '<span>' + service.name + '</span>';
    if (dealer.Services.length > serviceCount)
      serviceLine += ', ';
    
    jQuery(template).find('#services').append(serviceLine);
    serviceCount++;
  });
  
  var productLineCount = 1;
  jQuery.each(dealer.ProductLines, function(index, productLine) {
    if (productLine.status !== 'A') return;
    var productLinesLine = '<span>' + productLine.name + '</span>';
    if (dealer.ProductLines.length > productLineCount)
      productLinesLine += ', ';
    
    jQuery(template).find('#product-lines').append(productLinesLine);
    productLineCount++;    
  });
  
  return template;
}

function appendDealerToGallery(dealer) {
  jQuery('.dealers .grid').append(prepareDealerTemplate(dealer));
}

function getDealerFilterValues() {
  dealerFilter.productLines = '';
  jQuery('.dealers .filter.product-lines ul > li a.checked').each(function (index) {
    var id = jQuery(this).attr('id');
    if (id > 0)
      dealerFilter.productLines += id + ',';
  }); 
  dealerFilter.productLines = dealerFilter.productLines.substring(0, dealerFilter.productLines.length - 1)
  
  dealerFilter.dealerType = '';
  jQuery('.dealers .filter.dealer-types ul > li a.checked').each(function (index) {
    var id = jQuery(this).attr('id');
    if (id > 0)
      dealerFilter.dealerType += id + ',';
  });
  dealerFilter.dealerType = dealerFilter.dealerType.substring(0, dealerFilter.dealerType.length - 1)
  
  dealerFilter.services = '';
  jQuery('.dealers .filter.dealer-services ul > li a.checked').each(function (index) {
    var id = jQuery(this).attr('id');
    if (id > 0)
      dealerFilter.services += id + ',';
  });
  dealerFilter.services = dealerFilter.services.substring(0, dealerFilter.services.length - 1)
  
  dealerFilter.certificationLevel = '';
  jQuery('.dealers .filter.dealer-certification-levels ul > li a.checked').each(function (index) {
    var id = jQuery(this).attr('id');
    if (id > 0)
      dealerFilter.certificationLevel += id + ',';
  });
  dealerFilter.certificationLevel = dealerFilter.certificationLevel.substring(0, dealerFilter.certificationLevel.length - 1)
  
  dealerFilter.state = jQuery('.dealers #state').val();
  jQuery.cookie('dealerFilter', dealerFilter, { expires: 30, path: '/' });
}

function loadDealerFilterValues() {
  var searchOptionsSelected = false;
  
  if (dealerFilter.productLines) {
    jQuery('.dealers .filter.product-lines ul > li a').each(function (index) {
      var id = jQuery(this).attr('id');
      var productLines = dealerFilter.productLines.split(',');
      
      if (jQuery.inArray(id, productLines) > -1) {
        jQuery(this).addClass('checked');
        searchOptionsSelected = true;
      }
    });
  }
  
  if (dealerFilter.dealerType) {
    jQuery('.dealers .filter.dealer-types ul > li a').each(function (index) {
      var id = jQuery(this).attr('id');
      var dealerTypes = dealerFilter.dealerType.split(',');
      
      if (jQuery.inArray(id, dealerTypes) > -1) {
        jQuery(this).addClass('checked');
        searchOptionsSelected = true;
      }
    });
  }
  
  if (dealerFilter.services) {
    jQuery('.dealers .filter.dealer-services ul > li a').each(function (index) {
      var id = jQuery(this).attr('id');
      var services = dealerFilter.services.split(',');
      
      if (jQuery.inArray(id, services) > -1) {
        jQuery(this).addClass('checked');
        searchOptionsSelected = true;
      }
    });
  }
  
  if (dealerFilter.certificationLevel) {
    jQuery('.dealers .filter.dealer-certification-levels ul > li a').each(function (index) {
      var id = jQuery(this).attr('id');
      var certificationLevels = dealerFilter.certificationLevel.split(',');
      
      if (jQuery.inArray(id, certificationLevels) > -1) {
        jQuery(this).addClass('checked');
        searchOptionsSelected = true;
      }
    });
  }
  
  if (dealerFilter.state) {
   jQuery('.dealers #state').val(dealerFilter.state);
  }
  
  if (searchOptionsSelected)
    jQuery('.advanced-search-criteria').slideDown();
  
}

function anyFiltersUsed() {
  if (dealerFilter.productLines.length > 0 ||
    dealerFilter.dealerType.length > 0 ||
    dealerFilter.services.length > 0 ||
    dealerFilter.certificationLevel.length > 0 ||
    dealerFilter.state.length > 0
  ) {
    return true;
  }  
  
  return false;
}

function filterDealerResults() {
  getDealerFilterValues();
  
  dealerPage = 1;
  dealerLastPage = false;
  var parameters = '&productLine=' + dealerFilter.productLines + '&dealerType=' + dealerFilter.dealerType + '&dealerService=' + dealerFilter.services + '&dealerCertificationLevel=' + dealerFilter.certificationLevel + '&state=' + dealerFilter.state;
    
  jQuery.get('/marketplace/list?limit=9' + parameters, function(data) {
    jQuery('.dealers .grid').html('');
    if (data.length > 0 ) {      
      jQuery.each(data, function(index, dealer) {  
        
        appendDealerToGallery(dealer);
        
        if (dealerFilter.state.length > 1) {
          reCenterGoogleMaps(dealerFilter.state);
        }
        
        if (anyFiltersUsed())
          updateGoogleMapsMarkers(dealer);
        
        jQuery('#load-more').show();
      });
      
      if (!dealerFilter.state.length > 1) {
        reCenterGoogleMaps('United States');          
      }
    } else {
      jQuery('.dealers .grid').append("<p class='text-center'>No dealers found.</p>");
      jQuery('#load-more').hide();
    }
  }).always(function() {
    if (!anyFiltersUsed()){}
      loadInitialGoogleMarkers();
  });
  
}

function loadInitialGoogleMarkers() {   
  reCenterGoogleMaps('United States');        
  jQuery.get('/marketplace/list?limit=700', function(data) {
    if (data.length > 0 ) {      
      jQuery.each(data, function(index, dealer) {   
        updateGoogleMapsMarkers(dealer);     
      });
    } 
  });  
}